import { useMemo } from 'react';
import { useGetFormatMembersCount } from './useGetFormatMembersCount';

type P = {
  count: number;
};

export const useFormatMembersCount = (count: P) => {
  const getFormatMembersCount = useGetFormatMembersCount();
  return useMemo(() => getFormatMembersCount(count), [count, getFormatMembersCount]);
};
